<template>
  <div
    class="bg-primary-600 text-secondary-600 p-4"
  >
    <h1 class="text-[24px] mb-2 font-bold">{{ greeting }}</h1>
    <p class="text-xs">Enjoy shopping with {{ DistributorName }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAccountStore } from '@/stores/account';

const DistributorName = computed(() => useAccountStore().DistributorName);
const CustomerNames = computed(() => useAccountStore().CustomerNames);
const CustomerName = computed(() => {
  if (!CustomerNames.value?.length) return null;
  return CustomerNames.value.split(' ')[0];
});

const greeting = computed(() => {
  if (!CustomerName.value) return null;
  const currentHour = new Date().getHours();

  if (currentHour >= 5 && currentHour < 12) {
    return `Morning ${CustomerName.value}`;
  }
  if (currentHour >= 12 && currentHour < 18) {
    return `Afternoon ${CustomerName.value}`;
  }
  return `Evening ${CustomerName.value}`;
});
</script>
